import { useCreateOrUpdateDocumentInBibliography } from "@/api/related-fields";
import { LinkableType } from "@/components/LinksManagement";
import { FormLayoutElement } from "@/config/forms/general";
import { DocumentInBibliography } from "@/lib/types";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { z } from "zod";
import LinksDrawerLayout from "./LinksDrawerLayout";

const DocumentInBibliographyDrawer = ({
  fields,
  data,
  queryId,
  type,
  open,
  onOpenChange,
}: {
  fields: FormLayoutElement[] | undefined;
  data: DocumentInBibliography;
  queryId: string;
  type: LinkableType;
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
}) => {
  const schema = z.object({
    documentsDansBibliographieDescriptionReproduitPage: z.string().optional(),
    documentsDansBibliographieDescriptionCitePage: z.string().optional(),
    documentsDansBibliographieDescriptionPhotographe: z.string().optional(),
    documentsDansBibliographieDescriptionReproductionCouleur: z
      .boolean()
      .optional(),
    documentsDansBibliographieDescriptionNonPagine: z.boolean().optional(),
    bibliography: z.object({
      bibliographieDescriptionNumeroBibliographie: z.string().optional(),
      bibliographieDescriptionResumeLong: z.string().optional(),
    }),
  });

  const { mutate: createOrUpdateDocumentInBibliography } =
    useCreateOrUpdateDocumentInBibliography(queryId, type);

  const form = useForm<z.infer<typeof schema>>({
    resolver: zodResolver(schema),
    defaultValues: {
      bibliography: data.bibliography,
      documentsDansBibliographieDescriptionReproduitPage:
        data.documentsDansBibliographieDescriptionReproduitPage,
      documentsDansBibliographieDescriptionCitePage:
        data.documentsDansBibliographieDescriptionCitePage,
      documentsDansBibliographieDescriptionPhotographe:
        data.documentsDansBibliographieDescriptionPhotographe,
      documentsDansBibliographieDescriptionReproductionCouleur:
        data.documentsDansBibliographieDescriptionReproductionCouleur,
      documentsDansBibliographieDescriptionNonPagine:
        data.documentsDansBibliographieDescriptionNonPagine,
    },
  });

  const onSubmit = (formData: z.infer<typeof schema>) => {
    createOrUpdateDocumentInBibliography({
      id: data.id,
      documentId: data.document.id,
      bibliographyId: data.bibliography.id,
      ...formData,
    });
  };

  return (
    <LinksDrawerLayout
      form={form}
      fields={fields ?? []}
      recordId={data.id}
      onSubmit={onSubmit}
      open={open}
      onOpenChange={onOpenChange}
    />
  );
};

export default DocumentInBibliographyDrawer;
